import React, { Component } from 'react'
import axios from 'axios'
import Loader from '../components/Loader/Loader.jsx'
import Books from '../components/Books/Books.jsx'
import Announcement from '../components/Announcement/Announcement.jsx'
export default class read extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      error: '',
      books: [],
    }
  }
  componentDidMount = () => {
    axios
      .get(
        'https://wt-566da441a4b59d2631369d6ab2777d69-0.sandbox.auth0-extend.com/blogsection-library-dev-main'
      )
      .then(res => {
        const { data } = res
        const { read, toread, reading } = data
        this.setState({
          read: read,
          reading: reading,
          toread: toread,
          loading: false,
        })
      })
      .catch(error => {
        this.setState({
          loading: false,
          error: 'there is an error loading the quote',
        })
      })
  }
  readBooks = read => {
    Object.keys(read).map(function(key) {
      return <div>{read[key].title}</div>
    })
  }
  render() {
    const { read, toread, reading } = this.state
    return (
      <div className="main-wrapper animated fadeIn">
        <h1>
          My library
          <span className="title-end">_</span>
        </h1>
        <div className="subtitle">
          List of books I'm currently reading, read and planning to read.
        </div>
        <div className="books-list">
          {this.state.loading ? (
            <Loader message="loading reading list" />
          ) : (
            <div>
              <Books title="currently reading" books={reading} />
              <Announcement />
              <Books title="Just read" books={read} />
              <Books title="to read" books={toread} />
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/library.jsx